// Cross-login intent flag for the apply CTA. When a logged-out user taps a CTA
// we arm this flag, open login, then `router.invalidate()` re-runs the route
// loader so CVP resolves with the fresh `at`. CbccPostLoginResume then consumes
// the flag and dispatches the user's flow — so login continues the action with
// no second tap (mirrors fintech-ui's `callEligibilityCheck` handshake).
//
// sessionStorage (not in-memory) because the login sheet can remount the tree,
// and it's auto-scoped to the tab/session. All access is guarded + swallowed:
// a storage failure must never break the CTA.
const PENDING_FLOW_KEY = 'cbccPendingFlow';

export function armPendingFlow(): void {
	try {
		if (typeof window === 'undefined') return;
		window.sessionStorage.setItem(PENDING_FLOW_KEY, 'true');
	} catch {
		// ignore — storage unavailable (private mode / quota); CTA still works.
	}
}

/** Returns true once if a pending flow was armed, clearing it (single-shot). */
export function consumePendingFlow(): boolean {
	try {
		if (typeof window === 'undefined') return false;
		const armed = window.sessionStorage.getItem(PENDING_FLOW_KEY);
		if (armed) window.sessionStorage.removeItem(PENDING_FLOW_KEY);
		return !!armed;
	} catch {
		return false;
	}
}
